export default "__VITE_ASSET__5dee4a76__"